import template from './syncWindowSelector.html';
import controller from './syncWindowSelector.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    cssClass: '@',
  },
};

export default component;
